export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-3xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-8 md:p-12 lg:p-16 text-white">
                <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 text-white text-xs font-semibold mb-4 whitespace-nowrap backdrop-blur-sm">
                  移动端观影
                </span>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-black mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  随时随地，追综不间断
                </h2>
                <p className="text-white/80 text-sm md:text-base leading-relaxed mb-8 max-w-md">
                  51影视移动端适配完美，无论是通勤路上还是午休时间，打开手机就能畅享高清综艺。支持投屏到电视，大屏观影更过瘾。
                </p>
                <div className="flex flex-wrap gap-4">
                  <div className="flex items-center gap-3 bg-white/15 backdrop-blur-sm rounded-xl px-5 py-3 cursor-pointer hover:bg-white/25 transition-all">
                    <div className="w-10 h-10 flex items-center justify-center">
                      <i className="ri-android-line text-2xl"></i>
                    </div>
                    <div>
                      <div className="text-xs text-white/70">Android 版</div>
                      <div className="text-sm font-bold whitespace-nowrap">立即下载</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 bg-white/15 backdrop-blur-sm rounded-xl px-5 py-3 cursor-pointer hover:bg-white/25 transition-all">
                    <div className="w-10 h-10 flex items-center justify-center">
                      <i className="ri-apple-line text-2xl"></i>
                    </div>
                    <div>
                      <div className="text-xs text-white/70">iOS 版</div>
                      <div className="text-sm font-bold whitespace-nowrap">即将上线</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-1 flex justify-center lg:justify-end p-6 md:p-8">
                <div className="relative">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20colorful%20variety%20show%20streaming%20app%20interface%20with%20warm%20orange%20and%20coral%20theme%2C%20video%20thumbnails%20grid%20layout%2C%20clean%20UI%20design%2C%20floating%20phone%20on%20dark%20background%2C%20app%20screenshot%20style%2C%20professional%20product%20mockup%2C%20no%20visible%20personal%20data&width=400&height=600&seq=app-51movies&orientation=portrait"
                    alt="51影视移动端应用界面展示"
                    className="w-48 md:w-60 lg:w-72 h-auto object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}